import { useSearchUrl } from "./useFixUrl";

export const useAcquireQueryParamValue = (queryParamName: string = "q"): string => {
    const fullUrlVisited = useSearchUrl(),
        queryParams = new URLSearchParams(fullUrlVisited);
    return queryParams.get(queryParamName) || ""
}